import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { HiX, HiOutlineTrash, HiOutlineExclamation } from "react-icons/hi";
import FileIcon from "./FileIcon";

const PermanentDeleteModal = ({ isOpen, onClose, item, type, onConfirm, isProcessing }) => {
  if (!item) return null;

  const getFileExtension = (item) => {
    if (type === 'folder') return 'folder';
    return item.contentType?.split('/')[1] || 'file';
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={!isProcessing ? onClose : undefined}
            className="absolute inset-0 bg-slate-900/40 backdrop-blur-md"
          />

          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="relative w-full max-w-md bg-white rounded-[2.5rem] shadow-2xl overflow-hidden border border-rose-100"
          >
            <div className="p-8">
              {/* Header Icon */}
              <div className="flex justify-center mb-8">
                <div className="relative">
                  <div className="w-24 h-24 bg-rose-50 rounded-[2rem] flex items-center justify-center text-rose-600 shadow-inner">
                    <HiOutlineTrash size={40} className={isProcessing ? "animate-pulse" : ""} />
                  </div>
                  <div className="absolute -bottom-2 -right-2 bg-white p-2 rounded-xl shadow-lg border border-rose-100">
                    <HiOutlineExclamation className="text-rose-600 animate-bounce" size={20} />
                  </div>
                </div>
              </div>

              {/* Text Content */}
              <div className="text-center mb-8">
                <h3 className="text-2xl font-black text-slate-800 mb-3 tracking-tight">
                    Wipe Permanently?
                </h3>
                <p className="text-sm text-slate-500 font-medium px-4 leading-relaxed">
                  You are about to permanently erase <span className="text-rose-600 font-bold">"{item.name}"</span>. 
                  <span className="block mt-2 font-bold text-slate-400 uppercase text-[10px] tracking-widest">This action cannot be undone.</span>
                </p>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col gap-3">
                <button
                  disabled={isProcessing}
                  onClick={() => {
                    onConfirm(item, type);
                  }}
                  className="w-full px-8 py-4 bg-rose-600 hover:bg-rose-700 disabled:bg-rose-300 text-white rounded-2xl font-black shadow-xl shadow-rose-100 transition-all active:scale-95 flex items-center justify-center gap-3 uppercase tracking-widest text-[11px]"
                >
                  {isProcessing ? (
                    <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  ) : (
                    <HiOutlineTrash size={18} />
                  )}
                  {isProcessing ? "Processing..." : "Purge Now"}
                </button>
                <button
                  disabled={isProcessing}
                  onClick={onClose}
                  className="w-full px-6 py-4 bg-slate-50 hover:bg-slate-100 text-slate-400 hover:text-slate-600 rounded-2xl font-bold transition-all active:scale-95 text-xs uppercase tracking-widest"
                >
                  Keep for now
                </button>
              </div>
            </div>

            {/* Close button */}
            {!isProcessing && (
                <button 
                onClick={onClose}
                className="absolute top-6 right-6 p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-50 rounded-xl transition-all"
                >
                <HiX size={20} />
                </button>
            )}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default PermanentDeleteModal;
